const plugin = require('tailwindcss/plugin');

module.exports = {
    content: ['./**/*.php', './src/**/*.js'],
    important: false,
    darkMode: 'class',
    theme: {
        container: {
            center: true,
        },
        screens: {
            xsm: '375px',
            sm: '641px',
            md: '769px',
            lg: '1025px',
            xl: '1281px',
            '2xl': '1440px',
            '3xl': '1921px',
        },
        fontFamily: {
            sans: ['"lettera_text_lllight"', 'verdana'],
            'sans-medium': ['"lettera_text_llmedium"', 'verdana'],
            display: ['"ruder_plakat_llregular"', 'verdana'],
        },
        animation: {
            'loader-ripple': 'loader-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite',
        },
        keyframes: {
            'loader-ripple': {
                '0%': {
                    top: '36px',
                    left: '36px',
                    width: '8px',
                    height: '8px',
                    opacity: '0',
                },
                '4.9%': {
                    top: '36px',
                    left: '36px',
                    width: '8px',
                    height: '8px',
                    opacity: '0',
                },
                '5%': {
                    top: '36px',
                    left: '36px',
                    width: '8px',
                    height: '8px',
                    opacity: '1',
                },
                '100%': {
                    top: '0',
                    left: '0',
                    width: '80px',
                    height: '80px',
                    opacity: '0',
                },
            },
        },
        fontSize: {
            'h1-desktop': [
                '12.5rem',
                {
                    lineHeight: '90%',
                    letterSpacing: '0.625rem',
                    fontWeight: '400',
                },
            ],
            'h1-mobile': [
                '4rem',
                {
                    lineHeight: '100%',
                    letterSpacing: '0.28rem',
                    fontWeight: '400',
                },
            ],
            'h1-mobile-sm': [
                '3.6rem',
                {
                    lineHeight: '100%',
                    letterSpacing: '0.28rem',
                    fontWeight: '400',
                },
            ],
            'h2-desktop': [
                '7.5rem',
                {
                    lineHeight: '100%',
                    letterSpacing: '0.525rem',
                    fontWeight: '400',
                },
            ],
            'h2-mobile': [
                '3rem',
                {
                    lineHeight: '100%',
                    letterSpacing: '0.21rem',
                    fontWeight: '400',
                },
            ],
            'h3-desktop': [
                '5rem',
                {
                    lineHeight: '100%',
                    letterSpacing: '0.35rem',
                    fontWeight: '400',
                },
            ],
            'h3-mobile': [
                '2.25rem',
                {
                    lineHeight: '100%',
                    letterSpacing: '0.1575rem',
                    fontWeight: '400',
                },
            ],
            'h4-desktop': [
                '3.375rem',
                {
                    lineHeight: '100%',
                    letterSpacing: '0.23625rem',
                    fontWeight: '400',
                },
            ],
            'h4-mobile': [
                '1.75rem',
                {
                    lineHeight: '100%',
                    letterSpacing: '0.1225rem',
                    fontWeight: '400',
                },
            ],
            'h5-desktop': [
                '3.375rem',
                {
                    lineHeight: '110%',
                    letterSpacing: '-0.0675rem',
                    fontWeight: '400',
                },
            ],
            'h5-mobile': [
                '2rem',
                {
                    lineHeight: '110%',
                    letterSpacing: '-0.04rem',
                    fontWeight: '400',
                },
            ],
            'body-lg-desktop': [
                'calc(2rem*var(--x-1))',
                {
                    lineHeight: '120%',
                    letterSpacing: '-0.04rem',
                    fontWeight: '300',
                },
            ],
            'body-lg-mobile': [
                '1.25rem',
                {
                    lineHeight: '110%',
                    letterSpacing: '-0.025rem',
                    fontWeight: '300',
                },
            ],
            'body-sm-desktop': [
                'calc(1.5rem*var(--x-1))',
                {
                    lineHeight: '110%',
                    letterSpacing: '-0.03rem',
                    fontWeight: '300',
                },
            ],
            'body-sm-mobile': [
                '1rem',
                {
                    lineHeight: '110%',
                    letterSpacing: '-0.02rem',
                    fontWeight: '300',
                },
            ],
            'eyebrow-desktop': [
                'calc(1.25rem*var(--x-1))',
                {
                    lineHeight: '130%',
                    letterSpacing: '0.25rem',
                    fontWeight: '500',
                },
            ],
            'eyebrow-mobile': [
                '0.875rem',
                {
                    lineHeight: '130%',
                    letterSpacing: '0.175rem',
                    fontWeight: '500',
                },
            ],
            'large-body-desktop': [
                '2rem',
                {
                    lineHeight: '110%',
                    letterSpacing: '-0.04rem',
                },
            ],
            'large-body-mobile': [
                '1.25rem',
                {
                    lineHeight: '110%',
                    letterSpacing: '-0.025rem',
                },
            ],
        },
        extend: {
            colors: {
                'beccapr-black': 'var(--beccapr-black)',
                'beccapr-white': 'var(--beccapr-white)',
                'beccapr-yellow': 'var(--beccapr-yellow)',
                'beccapr-light-green': 'var(--beccapr-light-green)',
                'beccapr-dark-green': 'var(--beccapr-dark-green)',
                'beccapr-pink': 'var(--beccapr-pink)',
            },
            height: {
                'full-body': 'calc(100vh - var(--header-height))',
            },
            padding: {
                'container-top': 'var(--container-top-padding)',
                'container-bottom': 'var(--container-bottom-padding)',
                'container-left': 'var(--container-left-padding)',
                'container-right': 'var(--container-right-padding)',
                'container-sm-top': 'var(--container-sm-top-padding)',
                'container-sm-bottom': 'var(--container-sm-bottom-padding)',
                'container-sm-left': 'var(--container-sm-left-padding)',
                'container-sm-right': 'var(--container-sm-right-padding)',
                'container-md-top': 'var(--container-md-top-padding)',
                'container-md-bottom': 'var(--container-md-bottom-padding)',
                'container-md-left': 'var(--container-md-left-padding)',
                'container-md-right': 'var(--container-md-right-padding)',
            },
            margin: {
                'container-top': 'var(--container-top-padding)',
                'container-bottom': 'var(--container-bottom-padding)',
                'container-left': 'var(--container-left-padding)',
                'container-right': 'var(--container-right-padding)',
                'container-sm-top': 'var(--container-sm-top-padding)',
                'container-sm-bottom': 'var(--container-sm-bottom-padding)',
                'container-sm-left': 'var(--container-sm-left-padding)',
                'container-sm-right': 'var(--container-sm-right-padding)',
                'container-md-top': 'var(--container-md-top-padding)',
                'container-md-bottom': 'var(--container-md-bottom-padding)',
                'container-md-left': 'var(--container-md-left-padding)',
                'container-md-right': 'var(--container-md-right-padding)',
            },
            transitionDuration: {
                'menu-enter': 'var(--menu-enter)',
                'menu-leave': 'var(--menu-leave)',
                'submenu-enter': 'var(--submenu-enter)',
                'submenu-leave': 'var(--submenu-leave)',
                'nav-modal-enter': 'var(--nav-modal-enter)',
                'nav-modal-leave': 'var(--nav-modal-leave)',
                'nav-backdrop-enter': 'var(--nav-backdrop-enter)',
                'nav-backdrop-leave': 'var(--nav-backdrop-leave)',
                'button-enter': 'var(--button-enter)',
                'button-leave': 'var(--button-leave)',
                'footer-enter': 'var(--footer-enter)',
                'footer-leave': 'var(--footer-leave)',
                'image-zoom-enter': 'var(--image-zoom-enter)',
                'image-zoom-leave': 'var(--image-zoom-leave)',
                'link-enter': 'var(--link-enter)',
                'link-leave': 'var(--link-leave)',
                aos: 'var(--aos-duration)',
                100: '100ms',
                150: '150ms',
                200: '200ms',
                250: '250ms',
                300: '300ms',
                350: '350ms',
                400: '400ms',
                450: '450ms',
                500: '500ms',
                550: '550ms',
                600: '600ms',
                650: '650ms',
                700: '700ms',
                750: '750ms',
                800: '800ms',
                850: '850ms',
                900: '900ms',
                950: '950ms',
            },
            transitionDelay: {
                100: '100ms',
                150: '150ms',
                200: '200ms',
                250: '250ms',
                300: '300ms',
                350: '350ms',
                400: '400ms',
                450: '450ms',
                500: '500ms',
                550: '550ms',
                600: '600ms',
                650: '650ms',
                700: '700ms',
                750: '750ms',
                800: '800ms',
                850: '850ms',
                900: '900ms',
                950: '950ms',
            },
            transitionTimingFunction: {
                'in-quad': 'cubic-bezier(0.55, 0.085, 0.68, 0.53)',
                'out-quad': 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
                'in-out-quad': 'cubic-bezier(0.45, 0.03, 0.51, 0.91)',
                'in-cubic': 'cubic-bezier(0.55, 0.055, 0.675, 0.19)',
                'out-cubic': 'cubic-bezier(0.215, 0.61, 0.355, 1)',
                'in-out-cubic': 'cubic-bezier(0.645, 0.045, 0.355, 1)',
                'in-quart': 'cubic-bezier(0.895, 0.03, 0.685, 0.22)',
                'out-quart': 'cubic-bezier(0.165, 0.84, 0.44, 1)',
                'in-out-quart': 'cubic-bezier(0.77, 0, 0.175, 1)',
                'in-quint': 'cubic-bezier(0.755, 0.05, 0.855, 0.06)',
                'out-quint': 'cubic-bezier(0.23, 1, 0.32, 1)',
                'in-out-quint': 'cubic-bezier(0.86, 0, 0.07, 1)',
                'in-sine': 'cubic-bezier(0.47, 0, 0.745, 0.715)',
                'out-sine': 'cubic-bezier(0.39, 0.575, 0.565, 1)',
                'in-out-sine': 'cubic-bezier(0.445, 0.05, 0.55, 0.95)',
                'in-expo': 'cubic-bezier(0.95, 0.05, 0.795, 0.035)',
                'out-expo': 'cubic-bezier(0.19, 1, 0.22, 1)',
                'in-out-expo': 'cubic-bezier(1, 0, 0, 1)',
                'in-circ': 'cubic-bezier(0.6, 0.04, 0.98, 0.335)',
                'out-circ': 'cubic-bezier(0.075, 0.82, 0.165, 1)',
                'in-out-circ': 'cubic-bezier(0.785, 0.135, 0.15, 0.86)',
                'in-back': 'cubic-bezier(0.36, 0, 0.66, -0.56)',
                'out-back': 'cubic-bezier(0.34, 1.56, 0.64, 1)',
                'in-out-back': 'cubic-bezier(0.68, -0.55, 0.265, 1.55)',
                'in-elastic': 'cubic-bezier(0.87, 0, 0.13, 1)',
                'out-elastic': 'cubic-bezier(0.63, 0.04, 0.36, 1)',
                'in-out-elastic': 'cubic-bezier(0.68, -0.55, 0.27, 1.55)',
                'in-bounce': 'cubic-bezier(0.68, -0.55, 0.27, 1.55)',
                'out-bounce': 'cubic-bezier(0.68, -0.55, 0.27, 1.55)',
                'in-out-bounce': 'cubic-bezier(0.68, -0.55, 0.27, 1.55)',
            },
            fontWeight: {
                regular: '400',
            },
            scale: {
                'image-zoom': ['var(--image-zoom)'],
            },
            backgroundSize: {
                full: '100%',
            },
            backgroundImage: {
                'load-more-desktop-icon': 'url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iODQiIGhlaWdodD0iNDUiIHZpZXdCb3g9IjAgMCA4NCA0NSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggaWQ9IlZlY3RvciAyMiIgZD0iTTIgMkw0MiA0Mkw4MiAyIiBzdHJva2U9IiMyODI4MjgiIHN0cm9rZS13aWR0aD0iMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+Cjwvc3ZnPgo=")',

                'load-more-desktop-icon-dark': 'url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iODQiIGhlaWdodD0iNDUiIHZpZXdCb3g9IjAgMCA4NCA0NSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIgMkw0MiA0Mkw4MiAyIiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjMiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8L3N2Zz4K")',

                'load-more-mobile-icon': 'url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTkiIGhlaWdodD0iMTEiIHZpZXdCb3g9IjAgMCAxOSAxMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEuNjMzMyAxLjUxOTA0TDkuNDk5OTcgOS41MTkwNEwxNy4zNjY2IDEuNTE5MDQiIHN0cm9rZT0iIzI4MjgyOCIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPC9zdmc+Cg==")',

                'load-more-mobile-icon-dark': 'url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTkiIGhlaWdodD0iMTEiIHZpZXdCb3g9IjAgMCAxOSAxMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggaWQ9IlZlY3RvciAyNiIgZD0iTTEuNjMzMyAxLjUxOTA0TDkuNDk5OTcgOS41MTkwNEwxNy4zNjY2IDEuNTE5MDQiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+Cjwvc3ZnPgo=")',

                'dropdown-desktop-icon': 'url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTAiIHZpZXdCb3g9IjAgMCAxNyAxMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEgMS4yNUw4LjUgOC43NUwxNiAxLjI1IiBzdHJva2U9IiMyODI4MjgiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8L3N2Zz4K")',

                'dropdown-light-mobile-icon': 'url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTAiIHZpZXdCb3g9IjAgMCAxNyAxMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggaWQ9IlZlY3RvciAyMiIgZD0iTTEgMC45MDU3NjJMOC41IDguNDA1NzZMMTYgMC45MDU3NjQiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8L3N2Zz4K")',

                'dropdown-dark-mobile-icon': 'url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTAiIHZpZXdCb3g9IjAgMCAxNiAxMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAuNSAwLjkwNTc2Mkw4IDguNDA1NzZMMTUuNSAwLjkwNTc2NCIgc3Ryb2tlPSIjMjgyODI4IiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPC9zdmc+Cg==")',
            },
        },
    },
    plugins: [
        plugin(function ({ addVariant }) {
            addVariant('firefox', '@supports (-moz-appearance: none)');
        }),
    ],
};
